import styled from '@emotion/styled';
import { css } from 'theme-ui';
import pxToRem from '../../../utils/pixelsToRem';
import { GreenButton, TextButton } from '../buttons';
import { ThankYouBlock } from '../formBlocks';

export const RequestUpgradeWrapper = styled.div(
  css({
    mt: ['20px', '20px', '30px'],
    ml: [0, 0, 0, '210px'],
  }),
);

export const StyledGreenButton = styled(GreenButton)(
  css({
    padding: '12px 10px',
  }),
  ({ $isActive }) =>
    css({
      background: !$isActive && 'gray500',
      color: !$isActive && 'grayMidDark',
      pointerEvents: !$isActive && 'none',
    }),
);

export const TopRow = styled('div')(
  css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '15px',
  }),
);

export const BottomRow = styled('div')(
  css({
    display: 'flex',
    justifyContent: 'flex-end',
  }),
);

export const Form = styled.form(
  css({
    width: ['100%', '100%', 'auto'],
  }),
);

export const ModalBody = styled.div(
  ({ theme }) =>
    css({
      width: ['100%', '100%', 'auto'],
      background: theme.colors.veryDarkGreen,
      padding: '24px',
      overflowY: 'hidden',
    }),
  ({ $isSent }) =>
    css({
      height: $isSent && '65vh',
    }),
);

export const ModalTitle = styled.h3(({ theme }) =>
  css({
    color: theme.colors.focus,
    fontFamily: 'Lato',
    fontSize: pxToRem(18),
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: pxToRem(24),
    letterSpacing: '1.8px',
    textTransform: 'uppercase',
    marginBottom: '8px',
  }),
);

export const Description = styled.p(() =>
  css({
    color: 'white',
    fontFamily: 'Lato',
    fontSize: pxToRem(16),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: pxToRem(28),
    letterSpacing: '0.16px',
    marginBottom: '16px',
  }),
);
export const AlignedTextButton = styled(TextButton)(
  css({
    px: '16px',
    py: '8px',
  }),
);

export const FormBody = styled.div(
  css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '24px',
  }),
);

export const CustomThankYouBlock = styled(ThankYouBlock)(
  css({
    width: '100%',
    height: '100%',
    background: 'transparent',
    border: 'none',
    textAlign: 'center',
  }),
);
